const DEFAULT_AUTH_REDIRECT = "/news";

const isSafeInternalPath = (path) =>
  typeof path === "string" && path.startsWith("/") && !path.startsWith("//");

const getPathFromLocation = (location) => {
  if (!location) {
    return null;
  }

  if (typeof location === "string") {
    return location;
  }

  return `${location.pathname || ""}${location.search || ""}${
    location.hash || ""
  }`;
};

export const getAuthRedirect = (location) => {
  const searchParams = new URLSearchParams(location?.search || "");
  const queryRedirect =
    searchParams.get("redirect") || searchParams.get("referrer");

  if (typeof queryRedirect === "string" && isSafeInternalPath(queryRedirect)) {
    return queryRedirect;
  }

  const stateRedirect = getPathFromLocation(location?.state?.from);

  if (typeof stateRedirect === "string" && isSafeInternalPath(stateRedirect)) {
    return stateRedirect;
  }

  return DEFAULT_AUTH_REDIRECT;
};

export const buildAuthRedirectPath = (authPath, redirectPath) =>
  `${authPath}?redirect=${encodeURIComponent(redirectPath)}`;

export const BOOK_CLUB_PATH = "/community/book-club";
